import { renderWithLineBreaks } from 'utils/renderWithLineBreaks';

const NewsIcons = ({ items, className }) => {
  return (
    <div
      className={`news-icons flex full-width page-wrapper ${className ?? ''}`}
    >
      {items?.map((item, index) => (
        <div
          className='news-icons-item flex flex-column'
          key={item._key ?? index}
        >
          {item.iconUrl && (
            <img src={item.iconUrl} alt='' className='news-icons-icon' />
          )}
          <p className='news-icons-title balanced-text'>
            <span className='news-icons-title-primary font-primary'>
              {renderWithLineBreaks(item.titleGrotesk)}
            </span>{' '}
            <span className='news-icons-title-secondary font-secondary'>
              {renderWithLineBreaks(item.titleItalic)}
            </span>
          </p>
          {item.description && (
            <p className='news-icons-description font-primary'>
              {item.description}
            </p>
          )}
        </div>
      ))}
    </div>
  );
};

export default NewsIcons;
